import React from 'react'

const Label = ({ title, className, onClick, color }) => {
    return (
        <label className={className} color={color}>{title}</label>
    )
}

export default Label;
